import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { brand, brandDark } from "@/shared/lib/safecheckBrand";

function readCssVar(name: string, fallback: string): string {
  if (typeof window === "undefined") return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

export function useChartTheme() {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const isDark = mounted && resolvedTheme === "dark";
  const colors = isDark ? brandDark : brand;

  return {
    isDark,
    tick: isDark ? readCssVar("--muted-foreground", "#b0bdd4") : brand.navy,
    inactive: isDark ? readCssVar("--chart-inactive", "rgb(74 107 170 / 0.32)") : "#e9eef6",
    grid: isDark ? readCssVar("--chart-grid", "rgb(74 107 170 / 0.42)") : "#dce3ef",
    expenses: isDark ? readCssVar("--chart-grid", "rgb(74 107 170 / 0.42)") : "#dce3ef",
    tooltipClassName: "chart-tooltip",
    colors,
  };
}
